import { render, staticRenderFns } from "./Template.vue?vue&type=template&id=4c227e3c&scoped=true"
import script from "./Template.vue?vue&type=script&lang=ts"
export * from "./Template.vue?vue&type=script&lang=ts"
import style0 from "./Template.vue?vue&type=style&index=0&id=4c227e3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c227e3c",
  null
  
)

export default component.exports